import { type PreParsedSectionSettingProps, type SectionHandler } from '@capsicum/common';
import { useMemo } from 'react';

export const useEnhanceActions = (originalArray: Array<PreParsedSectionSettingProps>, onClickMap: SectionHandler) =>
	useMemo(
		() =>
			originalArray.map(item => {
				if (item.items.length > 0) {
					const modifiedItems = item.items.map(subItem => {
						if (subItem.action && onClickMap[subItem.action]) {
							return {
								...subItem,
								onPress: onClickMap[subItem.action]
							};
						}

						return subItem;
					});

					return {
						...item,
						items: modifiedItems
					};
				}

				return item;
			}),
		[originalArray, onClickMap]
	);
